export default __webpack_public_path__ + "static/media/main-app-black.638a156a.png";